<template>
  <div>
    <section class="home_head text-center" alt="" ondragstart="return false">
      <img :src="home_head_text" height="109px" width="1110px">
    </section>


    <section class="main-content home_role">

      <div class="el-row">
        <div class="text-center" style="width: 346px">
          <h5 class="animated fadeInUp">我们是<b>用户</b></h5>
          <div class="sudoku-role sudoku-role_user"></div>
          <div class="home-role-intro">客服、催收、信审、电销等多领域应用，我们一直是应用先锋。涵盖全牌照金融场景的新技术探索和应用：流程自动化、运营集中化、大数据、智能应用……</div>
        </div>
        <div class="text-center" style="width: 346px;margin: 0 30px">
          <h5 class="animated fadeInUp">我们是<b>厂商</b></h5>
          <div class="sudoku-role sudoku-role_manufacturer"></div>
          <div class="home-role-intro">提供多项自有技术及AI解决方案：一站式数字电话平台服务、一站式多媒体视频平台、智能语音和语义应用整体方案、智慧交警线上服务整体方案……</div>
        </div>
        <div class="text-center" style="width: 346px">
          <h5 class="animated fadeInUp">我们是<b>教练</b></h5>
          <div class="sudoku-role sudoku-role_coach"></div>
          <div class="home-role-intro">两大助力：智能众包式标注系统+专业标注人员、AI训练专家指导规则+完整的AI应用系统；四大优势：起步快、起点高、全外包、用得好；帮助您快速上线、优化。</div>
        </div>
      </div>
    </section>
    <section class="wow fadeIn home_hot" data-wow-duration="2s">
      <div class="main-content">
        <p class="wow fadeInDown text-center">——&nbsp;热门解决方案&nbsp;——</p>

        <div class="wrap_div">
          <button type="button" class="el-carousel__arrow el-carousel__arrow--left" @click="scrollBack"
                  v-if="leftMost"><i
            class="el-icon-arrow-left"></i></button>
          <el-scrollbar wrap-class="wrap-box" view-class="view-box" :native="false" noresize tag="ul"
                        ref="elscrollbar" style="scroll-behavior: smooth;width: 1110px;"
                        v-bind:style="{marginLeft:leftMost?'-45px':'0'}">
            <div class="hot_list" v-for="(solution,index) in solutions" :key="index"
                 v-bind:class="{'active': key == solution.id}" @click="whichSolution(solution)">
              <div class="hot_list_name"
                   v-bind:style="{borderRight:(solution.id=='008') || (key == solution.id)?'0':'1px solid #666'}">
                {{solution.name}}
              </div>
              <div class="hot_list_description"
                   v-bind:style="{borderRight:(solution.id=='008') || (key == solution.id)?'0':'1px solid #666'}">
                {{solution.description}}
              </div>
            </div>
          </el-scrollbar>
          <button type="button" class="el-carousel__arrow el-carousel__arrow--right" @click="scroll"
                  v-if="rightMost"><i
            class="el-icon-arrow-right"></i></button>
        </div>

        <div class="home_hot_content">

          <video class="wow fadeInLeft" controls preload="none" :poster="solutionCtnt.poster"
                 :src="solutionCtnt.videoUrl"></video>

          <div class="wow fadeInRight">
            <p class="hot_content_title text-left">{{solutionCtnt.title}}</p>
            <p class="hot_content_subTitle text-left">{{solutionCtnt.subTitle}}</p>
            <div class="hot_content_scenario">
              <p>适用行业场景</p>
              <div><span v-for="(_scenario,idx) in solutionCtnt.scenario" :key="idx">{{_scenario}}</span></div>
            </div>

            <div class="hot_content_correlation">
              <p>相关产品</p>

              <div class="correlation_div" style="display:inline-block"
                   v-for="(_correlation,idx) in solutionCtnt.correlation" :key="idx"
                   v-bind:style="{marginRight:idx%2==0?'16px':'0'}">
                <router-link :to="{path: '/product#'+_correlation.to}" @click.native="scrollTo(_correlation)">
                  <i class="sudoku-product-1" v-bind:class="_correlation.logo"></i>
                  <span>{{_correlation.title}}</span>
                </router-link>
              </div>

              <div class="correlation_button text-center" v-if="solutionCtnt.pdfUrl!='no'"><span v-on:click="openPDF(solutionCtnt)">查看方案详情</span></div>
              <!--i{-->
              <!--color: #C5CBD1;-->
              <!--border: 1px solid #C5CBD1;-->
              <!--float: right;-->
              <!--}-->
              <!--<i class="el-icon-arrow-right"></i>-->
            </div>
          </div>
        </div>

      </div>

    </section>
    <section class="wow fadeIn home_service" data-wow-duration="2s">
      <div class="main-content">
        <p class="wow fadeInDown text-center">——&nbsp;服务涵盖&nbsp;——</p>

        <div class="el-row">
          <div class="home-service-list wow slideInLeft" v-for="(service,index) in services" :key="index" v-bind:style="{borderRight:index==services.length-1?'1px solid rgba(233,233,233,0.20)':'0'}">
            <img v-lazy="service.logo" width="70px"/>
            <p>{{service.type}}</p>
          </div>
        </div>

      </div>
    </section>

    <section class="wow fadeIn home_cooperate" data-wow-duration="2s">

      <div class="main-content">
        <p class="wow fadeInDown text-center">——&nbsp;携手伙伴，共创AI生态系统&nbsp;——</p>

        <img class="wow fadeInUp" v-for="(cooperater,idx) in cooperaters" :key="idx" v-lazy="cooperater" width="145px" height="50px"
             v-bind:style="{marginRight:(idx == 4 || idx == 9)?'0':'94px'}"/>

      </div>
    </section>
  </div>
</template>

<script>
  import 'animate.css'
  import { WOW } from 'wowjs'
  import ElRow from "element-ui/packages/row/src/row";
  import ElCol from "element-ui/packages/col/src/col";
  // import CollectUserInfoDialog from "./CollectUserInfoDialog.vue";

  import home_head_bg from '../assets/img/home-head-bg.png'
  import home_head_text from '../assets/img/home-head-text.png'
  import finance_1 from '../assets/img/solution/finance-1.png'
  import finance_2 from '../assets/img/solution/finance-2.png'
  import finance_4 from '../assets/img/solution/finance-4.png'
  import finance_5 from '../assets/img/solution/finance-5.png'
  import finance_6 from '../assets/img/solution/finance-6.png'
  import finance_7 from '../assets/img/solution/finance-7.png'
  import MBA_2 from '../assets/img/solution/MBA-2.png'

  import BPO from '../assets/img/service/BPO.png'
  import energy from '../assets/img/service/energy.png'
  import finance from '../assets/img/service/finance.png'
  import industrialPark from '../assets/img/service/industrialPark.png'
  import smart110 from '../assets/img/service/smart110.png'
  import smartCity from '../assets/img/service/smartCity.png'

  import BC from '../assets/img/cooperaters/BC.png'
  import CBC from '../assets/img/cooperaters/CBC.png'
  import CCI from '../assets/img/cooperaters/CCI.png'
  import CDG from '../assets/img/cooperaters/CDG.png'
  import CE from '../assets/img/cooperaters/CE.png'
  import FOTIC from '../assets/img/cooperaters/FOTIC.png'
  import KFT from '../assets/img/cooperaters/KFT.png'
  import KP from '../assets/img/cooperaters/KP.png'
  import PAB from '../assets/img/cooperaters/PAB.png'
  import PALI from '../assets/img/cooperaters/PALI.png'
  import PAPH from '../assets/img/cooperaters/PAPH.png'
  import PSBOC from '../assets/img/cooperaters/PSBOC.png'
  import SINA from '../assets/img/cooperaters/SINA.png'
  import YQG from '../assets/img/cooperaters/YQG.png'

  import C1 from "../assets/videos/C1_1.mp4";
  import E1 from "../assets/videos/E1.mp4";
  import E3 from "../assets/videos/E3.mp4";
  import E6 from "../assets/videos/E6.mp4";
  import E7 from "../assets/videos/E7.mp4";
  import E8 from "../assets/videos/E8.mp4";
  export default {
    components: {
      // CollectUserInfoDialog
    },
    created: function () {
      this.solutionCtnt = this.solutions[0]
    },
    name: 'Home',
    mounted() { new WOW({live: false}).init() },
    data() {
      return {
        rightMost: true,
        leftMost: false,
        home_head_text: home_head_text,
        solutionCtnt: {},
        key: '001',
        solutions: [{
          id: '001',
          name: '智能电话客服',
          description: '全包服务、灵活定制、成熟经验',

          title: '智能电话客服整体解决方案',
          subTitle: '智能电话客服整体解决方案可解决客户体验不理想 人力成本高、人工效车低、风险监测希后等问题，优体验降成本',

          scenario: ['金融客服', '金融电销', '贷款信审', '贷款催收'],

          correlation: [{
            title: 'A1 一站式数字电话平台服务',
            logo: 'sudoku-A1',
            to: 'A1'
          }, {
            title: 'A3 一站式多媒体视频平台服务',
            logo: 'sudoku-A3',
            to: 'A3'
          }, {
            title: 'B1 通用客服作业系统',
            logo: 'sudoku-B1',
            to: 'B1'
          }, {
            title: 'C2 智能坐席助手',
            logo: 'sudoku-C2',
            to: 'C2'
          }],
          videoUrl: E1,
          poster: finance_1,
          pdfUrl: '/e_seal_web/static/pdf/E1智能电话客服整体解决方案.pdf'
        }, {
          id: '002',
          name: '智能催收',
          description: '全系统/工具支持、10年+业务经验',

          title: '智能催收整体解决方案',
          subTitle: '可应用于全业务、全客群、全周期催收场景，可提供全包/半包合作、应用工具/系统及相应高效策略，拥有集合10年+的催收业务经验及工具',

          scenario: ['金融公司', '银行', '消费信贷', '互联网金融', '贷后管理'],

          correlation: [{
            title: 'A1 一站式数字电话平台服务',
            logo: 'sudoku-A1',
            to: 'A1'
          }, {
            title: 'A2 一站式多媒体视频平台服务',
            logo: 'sudoku-A2',
            to: 'A2'
          }, {
            title: 'A3 智能电话机',
            logo: 'sudoku-A3',
            to: 'A3'
          }, {
            title: 'B2 催收系统',
            logo: 'sudoku-B2',
            to: 'B2'
          }],

          videoUrl: E3,
          poster: finance_2,
          pdfUrl: '/e_seal_web/static/pdf/E6智能催收整体解决方案.pdf'
        }, {
          id: '003',
          name: '智能信审',
          description: '智能化高效审核、可靠的评分体系',

          title: '智能信审解决方案',
          subTitle: '针对借款人信用审核采用线上视频面审的方式，应用远程核身风控技术，及反欺诈评分系统减少欺诈风险和坏账率。',

          scenario: ['小额贷款', '网贷平台', '互联网金融'],

          correlation: [{
            title: 'A3 一站式多媒体视频平台服务',
            logo: 'sudoku-A3',
            to: 'A3'
          }, {
            title: 'C4 智能质检系统',
            logo: 'sudoku-C4',
            to: 'C4'
          }, {
            title: 'D2 视频坐席',
            logo: 'sudoku-D2',
            to: 'D2'
          }],

          videoUrl: E6,
          poster: finance_4,
          pdfUrl: '/e_seal_web/static/pdf/E7智能信审解决方案.pdf'
        }, {
          id: '004',
          name: '视频查勘',
          description: '一站式视频报案，远程拍照、智能定损',

          title: '视频报案查勘解决方案',
          subTitle: '双方视频直面事故现场，减少用户等待查勘时间，优化用户体验；图片识别技术智能定损，系统智能化精确计算赔付金额。',

          scenario: ['车险公司', '产险公司'],

          correlation: [{
            title: 'A3 一站式多媒体视频平台服务',
            logo: 'sudoku-A3',
            to: 'A3'
          }, {
            title: 'D2 视频坐席',
            logo: 'sudoku-D2',
            to: 'D2'
          }],

          videoUrl: E7,
          poster: finance_5,
          pdfUrl: '/e_seal_web/static/pdf/E2视频报案查勘解决方案-20181207.pdf'
        }
//        , {
//          id: '005',
//          name: '印章集中管理',
//          description: '印章集中化管理，高可控、低风险',
//
//          title: '印章集中管理解决方案',
//          subTitle: '印章集中化管理，高可控性，降低企业印章滥用风险，让申请用印变得快速便捷',
//
//          scenario: ['大型集团', '财务部门', '采购部门', '政府部门'],
//
//          correlation: [{
//            title: 'C6 印章管理平台',
//            logo: 'sudoku-C6',
//            to: 'C6'
//          }, {
//            title: 'C14 电子签章平台',
//            logo: 'sudoku-C14',
//            to: 'C14'
//          }],
//
//          videoUrl: null,
//          poster: 'MBA_2',
//          pdfUrl: 'no'
//        }
        , {
          id: '006',
          name: '知识管理',
          description: '全渠道、多媒体，灵活对接多系统',

          title: '知识管理整体解决方案',
          subTitle: '结合客户画像、交互轨迹、大数据分析、智能搜索、知识图谱等新技术，提供精准优质的个性化知识服务',

          scenario: ['保险行业', '银行', '信用卡', '客服中心', '电话中心'],

          correlation: [{
            title: 'C1 智能知识平台',
            logo: 'sudoku-C1',
            to: 'C1'
          }],

          videoUrl: C1,

          poster: finance_7,
          pdfUrl: '/e_seal_web/static/pdf/E4知识管理整体解决方案-20181205.pdf'
        }, {
          id: '007',
          name: '智能视频客服',
          description: '智能化高效审核、可靠的评分体系',

          title: '智能视频客服解决方案',
          subTitle: '在线远程办理保单业务，视频双录，公安联网核实身份，电子签名确认等风控技术支持，合理规避风险，提升用户体验',

          scenario: ['保险行业'],

          correlation: [{
            title: 'A3 一站式多媒体视频平台服务',
            logo: 'sudoku-A3',
            to: 'A3'
          }, {
            title: 'D2 视频坐席',
            logo: 'sudoku-D2',
            to: 'D2'
          }],

          videoUrl: E8,

          poster: finance_6,
          pdfUrl: '/e_seal_web/static/pdf/E3智能视频客服解决方案.pdf'
        }, {
          id: '008',
          name: '更多解决方案',
          description: '点击这里，查看更多解决方案'
        }],
        services: [{
          logo: finance,
          type: '金融行业'
        }, {
          logo: smartCity,
          type: '智慧城市'
        }, {
          logo: smart110,
          type: '智慧交警'
        }, {
          logo: BPO,
          type: 'BPO外包行业'
        }, {
          logo: industrialPark,
          type: '智能产业园'
        }, {
          logo: energy,
          type: '电信能源'
        }],
        cooperaters:[BC,PSBOC,CCI,SINA,KP,CE,CBC,CDG,PAB,PAPH,PALI,KFT,YQG,FOTIC]
      }
    },
    methods: {
      whichSolution: function (solute) {
          if(solute.id == '008') this.$router.push({path: '/solution'})
          else {
              this.key = solute.id;
            this.solutionCtnt = solute
          }

      },
      scrollBack: function () {
        this.rightMost = true
        var div = this.$refs['elscrollbar'].$refs['wrap']
        if (div.scrollLeft >= 280) {
          this.leftMost = true
          this.$nextTick(() => {
            div.scrollLeft += -280
//            div.scrollBy({
//              'behavior': 'smooth',
//              'left': -280
//            })
          })
        } else if (div.scrollLeft > 0 && div.scrollLeft < 280) {
          this.leftMost = false
          this.$nextTick(() => {
            div.scrollLeft += -div.scrollLeft
//            div.scrollBy({
//              'behavior': 'smooth',
//              'left': -div.scrollLeft
//            })
          })
        } else {
          this.leftMost = false
        }
      },
      scroll: function () {
        var div = this.$refs['elscrollbar'].$refs['wrap']
        this.leftMost = true
        if (div.scrollLeft + 560 >= div.scrollWidth - div.offsetWidth) this.rightMost = false
        this.$nextTick(() => {
            div.scrollLeft += div.scrollLeft + 280
//          div.scrollBy({
//            'behavior': 'smooth',
//            'left': div.scrollLeft + 280
//          })
        })
      },
      openPDF(ctnt){
        const url = window.origin + ctnt.pdfUrl;
        window.open(url, '_blank');
        return false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue